
import '../styles/About.css'; // Import the CSS file for styling

const About = () => {

}

export default About;
